<script lang="ts">
    import { Button, Col } from "sveltestrap";
    import { href, SimplePricingCard } from "../../../../utils/Constant/Constant";
    import Card from "../../../Core/Card.svelte";
    import data from "../../../../Data/Ecommerce/Ecommerce.json"

</script>
<Col sm="12">
    <Card headerTitle={SimplePricingCard} cardHeaderprops="pb-0" cardBodyprops="pricing-content">
        <div slot="contentbody" class="row">
            {#each data.simplecarddata as pricingItem}
                <Col xl="3" sm="6" class="xl-50 box-col-6">
                    <div class="card text-center pricing-simple">
                        <div class="card-body">
                            <h3>{pricingItem.header}</h3>
                            <h1>{pricingItem.amount}</h1>
                            <h6 class="mb-0">{pricingItem.title}</h6>
                        </div>
                        <Button color="primary" size="lg" href={href}>
                            <h5 class="mb-0">{pricingItem.btnname}</h5>
                        </Button>
                    </div>
                </Col>
            {/each}
        </div>
    </Card>
</Col>